import { AuthApi } from 'woofwoof-api';
import client, { axiosBaseUrl } from './client';

export const authApi = new AuthApi(
  {
    basePath: axiosBaseUrl,
    isJsonMime: () => false,
  },
  undefined,
  //@ts-ignore
  client,
);
